import React from 'react';
import { gql } from '@urql/core';
import {
    PlayerConversationCardFragment,
    Espin_Role_Enum,
    Espin_Message_Type_Enum,
    Content_File,
} from '../../../../generated/spin-graphql';
import { useAppState } from '../../../../client/providers/AppProvider';
import { ConversationCard } from '../ConversationCard';

type Props = {
    conversation: PlayerConversationCardFragment;
    index: number;
    selected?: boolean;
    isFake?: boolean;
};

gql`
    fragment PlayerConversationCard on espin_message {
        player_user_id
        contents
        created_at
        viewed_at
        message_type
        college {
            logo {
                ...SpinContentImageDisplay
            }
            name
            slug
        }
    }
`;

export const PlayerConversationCard: React.FC<Props> = ({ conversation, index, selected, isFake }) => {
    const { user } = useAppState();
    let picture: Partial<Content_File>, nameLabel: string, lastMessage: string;
    if (isFake) {
        picture = null;
        nameLabel = `Message ${index + 1}`;
        lastMessage = conversation.contents;
    } else {
        picture = conversation?.college?.logo;
        nameLabel = conversation?.college?.name ?? 'Unverified College';

        const lastMessageWasFromYou =
            (user?.role === Espin_Role_Enum.EspinParentUser ||
                user?.role === Espin_Role_Enum.EspinPlayerUser ||
                user?.role === Espin_Role_Enum.EspinHighschoolUser) &&
            (conversation.message_type === Espin_Message_Type_Enum.PlayerMessagesCollege ||
                conversation.message_type === Espin_Message_Type_Enum.HighSchoolMessagesCollege);
        const lastMessageNameLabel = lastMessageWasFromYou ? 'You' : nameLabel;
        lastMessage = `${lastMessageNameLabel}: ${conversation.contents}`;
    }

    // if the college is not verified
    const slug = conversation?.college
        ? `/dashboard/messages/?college_slug=${conversation?.college.slug}`
        : `/dashboard/messages/`;
    return (
        <ConversationCard
            slug={slug}
            lastMessage={lastMessage}
            nameLabel={nameLabel}
            date={conversation.created_at}
            picture={picture}
            selected={selected}
            read={
                !!conversation.viewed_at || conversation.message_type !== Espin_Message_Type_Enum.CollegeMessagesPlayer
            }
        />
    );
};
